// this is an autogenerated file from DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/CheckRequirements/Requirement/NewTask/Content/Board/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_EditAutomation_EventActions_Content_EventAction_Content_Content_Content_CheckRequirements_Requirement_NewTask_Content_Board($location_id: uuid!) {
  tasks_boards(
    where: {
      status: { _eq: active }
      metadata: { _contains: { locations: [$location_id] } }
    }
    order_by: { name: asc }
  ) {
    id
    text: name
  }
}

`